import ClozeParagraphReadOnly from './ClozeParagraphReadOnly';

export default ClozeParagraphReadOnly;
